/**
 * Мобильный экран = ширина <= 768px (граница из спеки мобильной вёрстки).
 * Подключать локально в компоненты, где меняется поведение (не только CSS).
 */
export default {
  computed: {
    isMobileScreen () {
      return this.$vuetify.breakpoint.width <= 768
    },
  },
}
